var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showEnvironmentBar)?_c('div',{attrs:{"id":"envBar"}},[_c('span',{staticClass:"redBg"},[_c('router-link',{attrs:{"to":{ path: '/test' }}},[_vm._v(_vm._s(_vm.$t('testPage', { environment: _vm.store_getEnvironment })))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }